module.exports = __webpack_public_path__ + "8ae28685f6599757232746e26ccf172f.png";